import React from 'react';
import { FormattedMessage } from 'react-intl';

import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StyledConfidentialTicketWarning } from '@modules/cap/TicketList/constants/ticketlist.styled';

const UnclaimedAccountAlert = () => (
    <StyledConfidentialTicketWarning
        className="usa-alert gi-alert gi-alert__left-accent gi-alert__warning"
        id="unclaimed-account-alert"
        data-testid="unclaimed-account-alert"
        role="alert"
    >
        <div className="gi-alert__body">
            <FontAwesomeIcon
                icon={faExclamationTriangle}
                className="confidential-ticket-access-warning__icon"
                aria-hidden="true"
            />
            <p className="gi-alert__text">
                <FormattedMessage id="ticketManagement.sendMessage.unclaimedAccount.msg" />
            </p>
        </div>
    </StyledConfidentialTicketWarning>
);

export default UnclaimedAccountAlert;
